<script>
import Swal from "sweetalert2";

import router from "@/router";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Form from '@/components/packages/form'

export default {
    page: {
    title: "Create Package",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Form
  },
  data() {
    return {
      title: "Add a new package",
      items: [
        {
          text: "Packages",
          href: "/packages",
        },
        {
          text: "Create",
          active: true,
        },
      ],
    }
  },
  methods: {
    tiggerExit() {
      Swal.fire({
        title: "Are you sure?",
        text: "Any unsaved progress will be lost",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#1D99C7",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, exit"
      }).then(result => {
        if (result.value) {
          router.push({ path: '/packages' })
        }
      });
    }
  }
}

</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row mb-3">
      <div class="col-12 text-right">
        <b-button variant="outline-primary" class="w-sm" @click="tiggerExit">
          <i class="bx bx-chevron-left font-size-16 align-middle mr-2" /> Exit
        </b-button>
      </div>
    </div>
    <Form />
  </Layout>
</template>